import { useEffect } from "react";
import { useAuth } from "@/auth/auth-context";
import { setTokenGetter } from "@/lib/api";

/** Registers the auth token getter with the api-client singleton. Mounted once by <Providers>. */
export function ApiTokenBridge() {
  const auth = useAuth();
  useEffect(() => {
    setTokenGetter(auth.getToken);
  }, [auth.getToken]);
  return null;
}
